export default "__VITE_ASSET__CdpJEwL9__"